import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Subscription} from 'rxjs';
import {PromoHandlerService} from './promo-handler.service';

@Component({
    selector: 'lib-promo-handler',
    templateUrl: './promo-handler.component.html',
    styleUrls: ['./promo-handler.component.scss']
})
export class PromoHandlerComponent implements OnInit, OnDestroy {

    @Input() apiUrl = null;
    @Input() userData = null;

    // @ts-ignore
    $subs: Subscription;

    constructor(
        private auth: AuthService,
        private route: ActivatedRoute,
        private router: Router,
        private http: HttpClient,
        private service: PromoHandlerService
    ) {

    }

    ngOnInit() {
        this.storePromoId();
    }

    ngOnDestroy() {
        if (this.$subs) {
            this.$subs.unsubscribe();
        }
    }

    storePromoId() {
        const queryParams: any = {...this.route.snapshot?.queryParams};
        if (queryParams?.prC) {
            this.service.localPromoCode = queryParams?.prC;
            delete queryParams.prC;
            this.router.navigate([''], {
                relativeTo: this.route,
                queryParams
            })
                .then(() => {
                });
        }
    }
}
